export default "__VITE_PUBLIC_ASSET__b17680f2__"